import { HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";

import {
  InfrastructureError,
  InfrastructureErrorType,
} from "@app/core/shared/data/network/errors/infrastructure.error";
import { AuthorizationError } from "@app/core/shared/data/network/errors/authorization.error";
import { TranslatedError } from "@app/core/shared/data/network/errors/translated.error";
import { NoInternetError } from "@app/core/shared/data/network/errors/no-internet.error";

export class BaseHandlerErrorMapper {
  static handleError(
    errorResponse: HttpErrorResponse
  ): Observable<never> | Observable<false> {
    //If the error contains a message, throw it a new error with that message
    let apiError;
    let error = errorResponse.error;
    switch (errorResponse.status) {
      case 0:
        throw new NoInternetError();
      case 400:
        throw new TranslatedError(error.error_message);
      case 401:
        apiError = {
          code: error.error_code,
          message: error.error_message,
          status: error.error_status,
        };
        throw new AuthorizationError(
          error,
          "authentication_error_email_password",
          apiError
        );
      case 403:
        if(error.error_message && error.error_message === 'Token inválido.') {
          window.location.replace('/logout')
        }
        apiError = {
          code: error.error_code,
          message: error.error_message,
          status: error.error_status,
        };
        throw new AuthorizationError(error, "error_forbidden", apiError);
      case 404:
        throw new InfrastructureError(
          InfrastructureErrorType.BackendError,
          error,
          "error_not_found"
        );
      case 500:
        throw new InfrastructureError(
          InfrastructureErrorType.InternalServerError,
          error,
          "error_internal_server_error"
        );
      case 504:
        throw new InfrastructureError(
          InfrastructureErrorType.TimeOutError,
          error,
          "error_timeout"
        );
      default:
        throw new InfrastructureError(
          InfrastructureErrorType.BackendError,
          error,
          "unknown"
        );
    }
  }
}
